import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormLogin from "../../components/FormLogin";
import "./style.css";
import img_logo from "../../../assets/icons/logo.png";
import img_login from "../../../assets/icons/login.png";

import { translate } from "../../translate";

class Login extends Component {
    render() {
        return (
            <div id="login" className="box-center">
                <div className="box-login">
                    <img className="iconLogin" src={img_login} alt="Login" />
                    <h1 className="text-center">{translate("wAttend", "wAttend")}</h1>

                    <FormLogin />

                    <img className="iconLogo" src={img_logo} alt="Logo" />

                </div>
            </div>
        )
    }
}

// "state" is set in reducers/index.js
function mapStateToProps(state) {
    return {
        //user: state.user
    };
}

export default connect(mapStateToProps)(Login);